exelare_jobs.define('settingsMgr',['jquery'], function ($) {
    return function (args, callback) {
    	var setts = {};
        exelare_jobs.require([EXELARE_SVC_URL + "settings.js"], function (glb_sets) {
            //console.log(glb_sets);

            $.extend(setts, glb_sets);

            setts.curCompanyId = args.companyId;
            setts.curUserId = args.userId;
            setts.curPwd = args.pwd;

            //dynamic settings
            var settingsPath = EXELARE_SVC_URL + "CustomSettings/" + args.companyId + "/settings.js"
            urlExists(settingsPath, function(_exists) {
                if (_exists) {
                    exelare_jobs.require([settingsPath], function (loc_sets) {
                        $.extend(setts, loc_sets);
                        callback(setts);
                    });
                } else {
                    callback(setts);
                }    
            });
        });
    }
})






;
